import { useState } from 'react'
import { Modal, Table, Radio, Button, Typography, Alert } from 'antd'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import INTERNAL_PROPERTIES from './internalProperties'

const { Title, Text } = Typography

const DuplicateSelectionModal = ({
  visible,
  onCancel,
  onConfirm,
  duplicateRows,
  mapping,
  duplicatePartNos,
}) => {
  const { t } = useTranslation()
  const [selectedRows, setSelectedRows] = useState({})

  const partNoCol = mapping?.id_part_client

  const handleConfirm = () => {
    const selectedData = {}
    Object.entries(selectedRows).forEach(([partNo, rowIndex]) => {
      selectedData[partNo] = duplicateRows[partNo][rowIndex]
    })
    onConfirm(selectedData)
  }

  const isAllSelected = duplicatePartNos.every(
    (partNo) => selectedRows[partNo] !== undefined,
  )

  const columns = [
    {
      title: t('parts_master_data.upload.select_column'),
      key: 'select',
      width: 80,
      render: (_, record, index) => (
        <Radio
          checked={selectedRows[record[partNoCol]] === index}
          onChange={() =>
            setSelectedRows((prev) => ({ ...prev, [record[partNoCol]]: index }))
          }
        />
      ),
    },
    ...INTERNAL_PROPERTIES.filter((p) => mapping?.[p.name]).map((p) => ({
      title: mapping[p.name],
      dataIndex: mapping[p.name],
      key: p.name,
    })),
  ]

  return (
    <Modal
      title={t('parts_master_data.upload.duplicate_modal_title')}
      open={visible}
      onCancel={onCancel}
      width={1000}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          {t('cancel_button')}
        </Button>,
        <Button
          key="confirm"
          type="primary"
          onClick={handleConfirm}
          disabled={!isAllSelected}
        >
          {t('parts_master_data.upload.continue_button')}
        </Button>,
      ]}
    >
      <Alert
        message={t(
          'parts_master_data.upload.part_excel_duplicate_entries_header',
        )}
        type="warning"
        showIcon
        style={{ marginBottom: 16 }}
      />
      {duplicatePartNos.map((partNo) => (
        <div key={partNo} style={{ marginBottom: 24 }}>
          <Title level={5}>
            {t('Part No')}: {partNo}
          </Title>
          <Text type="secondary">
            {t('parts_master_data.upload.select_one_from_duplicates', {
              count: duplicateRows[partNo].length,
            })}
          </Text>
          <Table
            columns={columns}
            dataSource={duplicateRows[partNo].map((row, index) => ({
              ...row,
              key: `${partNo}-${index}`,
            }))}
            pagination={false}
            size="small"
            style={{ marginTop: 8 }}
          />
        </div>
      ))}
    </Modal>
  )
}

DuplicateSelectionModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  duplicateRows: PropTypes.object.isRequired,
  mapping: PropTypes.shape({
    id_part_client: PropTypes.string.isRequired,
  }),
  duplicatePartNos: PropTypes.array.isRequired,
}

export default DuplicateSelectionModal
